<mat-toolbar class="mc-toolbar-large" color="basic">
  <ng-container *ngIf="projectFile">
    <ng-container *ngIf = "showLineCount">
      <span>{{ fileLineCount$ | async | mcPluralize : 'line' }}</span>
      <mat-divider [vertical]="true"></mat-divider>
    </ng-container>
    <span>{{ projectFile.Size | mcFileSize }}</span>
  </ng-container>
  <ng-content></ng-content>
</mat-toolbar>
